import TheSidebar from "@/components/TheSidebar";
import TheTopbar from "@/components/TheTopbar";
import AppAlert from "@/components/AppAlert";
import AppIcon from "@/components/AppIcon";
import PdfRenderer from "@/components/PdfRenderer.vue";
import { EVENTS } from "@/utils/constants";
export default {
  name: "TheWrapperPrivate",
  props: {
    innerScroll: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isCollapsed: true,
      isHovering: false,
      currentBreadcrumbs: [{
        text: "Dashboard",
        to: "/"
      }],
      style: {
        collapsed_unhovering: {
          ["--wrapper-private-sidebar-width"]: "4.85rem",
          justifyContent: "center",
          ["--wrapper-private-mainpage-width"]: "calc(100vw - 4.85rem)"
        },
        collapsed_hovering: {
          ["--wrapper-private-sidebar-width"]: "17.14rem",
          justifyContent: "start",
          ["--wrapper-private-sidebar-box-shadow"]: "7px 0 16px 0 rgba(77, 77, 77, 0.3)",
          ["--wrapper-private-sidebar-border-radius"]: "0 16px 16px 0",
          ["--wrapper-private-mainpage-width"]: "calc(100vw - 4.85rem)"
        },
        expanded: {
          ["--wrapper-private-sidebar-width"]: "17.14rem",
          justifyContent: "start",
          ["--wrapper-private-mainpage-width"]: "calc(100vw - var(--wrapper-private-sidebar-width))"
        }
      },
      isProfileSettingsShown: false,
      showTopAccountListView: false
    };
  },
  methods: {
    handleCollapse(value) {
      this.isCollapsed = value;
    },
    handleHoveringOn(value) {
      this.isHovering = value;
    },
    handleHoveringOff(value) {
      this.isHovering = value;
    },
    updateBreadcrumbs(breadcrumbs) {
      this.currentBreadcrumbs = breadcrumbs;
    },
    handleClickOutside() {
      if (this.isProfileSettingsShown || this.showTopAccountListView) {
        this.isProfileSettingsShown = false;
        this.showTopAccountListView = false;
        this.isHovering = false;
      }
    },
    handleProfileSettingsClick() {
      this.isProfileSettingsShown = !this.isProfileSettingsShown;
    },
    closeProfileSettingsPanel() {
      this.isProfileSettingsShown = false;
    },
    handleTopAccountBtnClicked() {
      this.showTopAccountListView = !this.showTopAccountListView;
    }
  },
  computed: {
    homepageStyle() {
      const state = !this.isCollapsed ? "expanded" : this.isHovering ? "collapsed_hovering" : "collapsed_unhovering";
      window.$bus.trigger(EVENTS.SIDEBAR_CHANGED);
      return this.style[state];
    },
    padded() {
      return this.$store.state.padded ? {
        padding: "0 1rem 1rem 1rem"
      } : {};
    }
  },
  components: {
    TheSidebar,
    TheTopbar,
    AppAlert,
    PdfRenderer,
    AppIcon
  }
};